import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { publicAxios } from "../../../config/apiConfig";

export default function UnsubscribePage() {
    const [searchParams] = useSearchParams();
    const [message, setMessage] = useState("Processing unsubscription...");
    const navigate = useNavigate();

    useEffect(() => {
        const token = searchParams.get("token");
        if (!token) {
            setMessage("❌ Invalid request, no token found.");
            return;
        }

        publicAxios.get(`unsubscribe?token=${token}`)
            .then(async (res) => {
                const text = await res.text();
                setMessage(text);
            })
            .catch(() => setMessage("❌ Something went wrong."));
    }, [searchParams]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
            <div className="w-full max-w-md bg-white p-6 rounded-2xl shadow-lg text-center flex flex-col justify-between">
                {/* Content */}
                <div className="flex flex-col items-center">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">
                        {message || "Unsubscription successful"}
                    </h2>
                    <p className="text-gray-600 leading-relaxed">
                        You have been unsubscribed. You will no longer receive updates from us.
                    </p>
                </div>

                {/* Footer / Button */}
                <div className="mt-8">
                    <button
                        onClick={() => navigate("/")}
                        className="w-full px-4 py-3 bg-red-600 text-white font-semibold rounded-lg shadow hover:bg-red-700 transition"
                    >
                        Go Home
                    </button>
                </div>
            </div>
        </div>

    );
}
